// Global variables
let product;
let currentVariant;

function initVariantSelector() {
  const productContainer = document.getElementById('product-container');
  if (!productContainer) return;

  const productId = productContainer.dataset.productId;
  product = JSON.parse(document.getElementById(`ProductJson-${productId}`).textContent);

  sortOptionElements();
  initOptionSelectors();

  // Hide initial price until we select a valid variant
  hideInitialPrice();

  // Find first option1 that has available second options
  const firstValidOption = findFirstValidOption();
  if (firstValidOption) {
    const firstOption1Input = document.querySelector(`[data-option-position="1"][value="${firstValidOption}"]`);
    if (firstOption1Input) {
      // Instead of just clicking, we need to ensure the UI is updated
      firstOption1Input.checked = true;
      updateSecondOptions(firstValidOption);

      // Find and select first available option2
      const option2Container = document.querySelector('[data-option-container="2"]');
      if (option2Container) {
        const firstAvailableOption2 = option2Container.querySelector('.variant-selector:not([disabled])');
        if (firstAvailableOption2) {
          firstAvailableOption2.checked = true;
          // Manually trigger variant update after both options are selected
          updateSelectedVariant();
        }
      }
    }
  }
}

function hideInitialPrice() {
  const priceElement = document.querySelector('.current-price');
  const comparePriceElement = document.querySelector('.compare-at-price');

  if (priceElement) {
    priceElement.style.visibility = 'hidden';
  }
  if (comparePriceElement) {
    comparePriceElement.style.visibility = 'hidden';
  }
}

function showPrices() {
  const priceElement = document.querySelector('.current-price');
  const comparePriceElement = document.querySelector('.compare-at-price');

  if (priceElement) {
    priceElement.style.visibility = 'visible';
  }
  if (comparePriceElement) {
    comparePriceElement.style.visibility = 'visible';
  }
}

function sortOptionElements() {
  const option2Container = document.querySelector('[data-option-container="2"] .swiper-wrapper');
  if (!option2Container) return;

  // Get all option labels
  const labels = Array.from(option2Container.querySelectorAll('label'));

  // Sort labels based on the numeric values in the option text
  labels.sort((a, b) => {
    const aValue = parseOptionValue(a.querySelector('input').value);
    const bValue = parseOptionValue(b.querySelector('input').value);
    return aValue - bValue;
  });

  // Reappend labels in sorted order
  labels.forEach((label) => {
    option2Container.appendChild(label);
  });
}

function parseOptionValue(value) {
  // Extract the first number from strings like "8-10 cm"
  const match = value.match(/(\d+)/);
  return match ? parseInt(match[0]) : 0;
}

function findFirstValidOption() {
  // Loop through all option1 values
  const option1Values = new Set(product.variants.map((variant) => variant.option1));

  for (const option1Value of option1Values) {
    // Get all variants for this option1
    const variantsForOption1 = product.variants.filter((variant) => variant.option1 === option1Value);

    // Check if any of these variants are available
    const hasAvailableVariants = variantsForOption1.some((variant) => variant.available);

    if (hasAvailableVariants) {
      return option1Value;
    }
  }

  return null;
}

function initOptionSelectors() {
  document.querySelectorAll('.variant-selector').forEach((input) => {
    input.addEventListener('change', handleOptionChange);
  });
}

function handleOptionChange(event) {
  const optionPosition = event.target.getAttribute('data-option-position');

  if (optionPosition === '1') {
    updateSecondOptions(event.target.value);
  }

  updateSelectedVariant();
}

function updateSecondOptions(selectedHeight) {
  const option2Container = document.querySelector('[data-option-container="2"]');
  if (!option2Container) return;

  // Get all variants for the selected height
  const heightVariants = product.variants.filter((variant) => variant.option1 === selectedHeight);

  // Add am beliebtesten
  const variants = product.variants;

  variants.forEach((variant) => {
    if (variant.option1 === selectedHeight) {
      var variantId = variant.id;
      var variantMetafield = document.querySelector(`[data-stock-id="${variantId}"]`);
      var amBeliebtesten = variantMetafield.getAttribute('data-am-beliebtesten');
      if (amBeliebtesten === 'true') {
        var amBeliebtestenHtml = document.querySelector('.am-beliebtesten');
        if (amBeliebtestenHtml === null) {
          var option1 = variant.option1;
          var stamhohe = '#stammhohe-' + option1.replace(' ', '-');
          var optionHtml = document.querySelector(stamhohe);
          var optionDiv = optionHtml.nextElementSibling;
          const span = document.createElement('span');
          span.classList.add('am-beliebtesten', 'bg-accent', 'text-black', 'rounded-md', 'px-2', 'text-xs');
          span.textContent = 'Am beliebtesten';
          optionDiv.append(span);
        }
      }
    } else {
      var variantId = variant.id;
      var variantMetafield = document.querySelector(`[data-stock-id="${variantId}"]`);
      var amBeliebtesten = variantMetafield.getAttribute('data-am-beliebtesten');
      if (amBeliebtesten === 'true') {
        var amBeliebtestenHtml = document.querySelector('.am-beliebtesten');
        if (amBeliebtestenHtml === null) {
          var option1 = variant.option1;
          var stamhohe = '#stammhohe-' + option1.replace(' ', '-');
          var optionHtml = document.querySelector(stamhohe);
          var optionDiv = optionHtml.nextElementSibling;
          const span = document.createElement('span');
          span.classList.add('am-beliebtesten', 'bg-accent', 'text-black', 'rounded-md', 'px-2', 'text-xs');
          span.textContent = 'Am beliebtesten';
          optionDiv.append(span);
        }
      }
    }
  });

  // Get all option2 values that exist for this height
  const existingOption2Values = heightVariants.map((variant) => variant.option2);

  // Get available (in stock) option2 values for this height
  const availableOption2Values = heightVariants
    .filter((variant) => variant.available)
    .map((variant) => variant.option2);

  const nonAvailableOption2Values = heightVariants.map((variant) => variant.option2);

  // Update each option2 input
  option2Container.querySelectorAll('.variant-selector').forEach((input) => {
    const label = input.closest('label');

    if (existingOption2Values.includes(input.value)) {
      // Show the option if it exists for this height
      label.style.display = '';

      if (availableOption2Values.includes(input.value)) {
        // Option is in stock
        input.disabled = false;
        label.classList.remove('disabled');
      } else {
        // Option exists but is out of stock
        //input.disabled = true;
        label.classList.add('disabled');
      }
    } else {
      // Option doesn't exist for this height at all
      label.style.display = 'none';
      //input.disabled = true;
      if (input.checked) {
        input.checked = false;
      }
    }
  });

  // Select first available option2 if none is selected
  const hasSelectedOption2 = Array.from(option2Container.querySelectorAll('.variant-selector')).some(
    (input) => input.checked && !input.disabled
  );

  if (!hasSelectedOption2) {
    const firstAvailableOption2 = option2Container.querySelector('.variant-selector:not([disabled])');
    if (firstAvailableOption2) {
      firstAvailableOption2.click();
    }
  }

  var swiper3 = new Swiper('.mySwiper3', {
    mousewheel: true,
    slidesPerView: 'auto',
    spaceBetween: 16,
    scrollbar: {
      el: '.product-variants-scrollbar',
      hide: false,
      draggable: true,
    },
    breakpoints: {
      640: {
        mousewheel: false,
        draggable: false,
      },
    },
  });
}

function updateSelectedVariant() {
  const selectedOptions = [];

  const option1Selected = document.querySelector('[data-option-position="1"]:checked');
  const option2Selected = document.querySelector('[data-option-position="2"]:checked');

  if (option1Selected && option2Selected) {
    selectedOptions.push(option1Selected.value, option2Selected.value);

    // Find the matching variant
    currentVariant = product.variants.find((variant) =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );

    updateUI();
  }
}

function updateUI() {
  if (!currentVariant) return;

  // Update price
  const priceElement = document.querySelector('.current-price');
  const comparePriceElement = document.querySelector('.compare-at-price');

  if (priceElement) {
    priceElement.innerHTML = `${(currentVariant.price / 100).toFixed(2).replace('.', ',')} €`;
    priceElement.setAttribute('data-price', currentVariant.price);
  }

  if (comparePriceElement) {
    if (currentVariant.compare_at_price) {
      comparePriceElement.innerHTML = `${(currentVariant.compare_at_price / 100).toFixed(2).replace('.', ',')} €`;
      comparePriceElement.setAttribute('data-compare-price', currentVariant.compare_at_price);
      comparePriceElement.style.display = 'inline';
    } else {
      comparePriceElement.style.display = 'none';
    }
  }

  // Show prices after we've updated them
  showPrices();

  // Update variant ID
  const variantIdInput = document.querySelector('input[name="id"]');
  const stockInput = document.querySelector(`[data-stock-id="${currentVariant.id}"]`);
  const stockValue = stockInput.getAttribute('data-stock');
  const quantityInput = document.querySelector('input[name="quantity"]');
  if (variantIdInput) {
    variantIdInput.value = currentVariant.id;
  }
  if (quantityInput) {
    quantityInput.setAttribute('max', stockValue);
  }

  // Update add to cart button
  const addToCartButton = document.querySelector('button[type="submit"]');
  if (addToCartButton) {
    if (currentVariant.available) {
      addToCartButton.disabled = false;
      addToCartButton.textContent = 'In den Warenkorb legen';
    } else {
      addToCartButton.disabled = true;
      addToCartButton.textContent = 'Ausverkauft';
    }
  }

  // Update option1 availability state
  updateOption1State();

  // Dispatch variant changed event
  const event = new CustomEvent('variant:changed', { detail: { variant: currentVariant } });
  document.dispatchEvent(event);
}

function updateOption1State() {
  const option1Container = document.querySelector('[data-option-container="1"]');
  if (!option1Container) return;

  option1Container.querySelectorAll('.variant-selector').forEach((input) => {
    const label = input.closest('label');

    // Check if this height has any variants in stock
    const hasAvailableVariants = product.variants.some(
      (variant) => variant.option1 === input.value && variant.available
    );

    if (hasAvailableVariants) {
      input.disabled = false;
      label.classList.remove('disabled');
    } else {
      //input.disabled = true;
      label.classList.add('disabled');
    }
  });
}

document.addEventListener('DOMContentLoaded', initVariantSelector);
